import { type UseQueryResult, useQuery } from 'react-query';
import {
  RsuAwardService,
  TransactionService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_Transactions_TransactionDto,
} from '../../services/wealthlane-award-services';

const useGetExtraTransactionById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string,
  applyConfig?: any
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_Transactions_TransactionDto | undefined,
  unknown
> => {
  const extraTransactionById = useQuery(['getExtraTransactionById', id, applyConfig], async () => {
    if (id) {
      return await handleRequest(
        TransactionService.getApiAwardApiAppTransactionTransactionById(
          id,
          applyConfig?.intendedShareRegistrationTypeId,
          applyConfig?.transactionAcquisitionTypeId
        )
      );
    }
  });

  return extraTransactionById;
};

export default useGetExtraTransactionById;
